(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementBulkEditDialogController', UserManagementBulkEditDialogController);

    UserManagementBulkEditDialogController.$inject = ['$uibModalInstance', 'selectionCount', 'selectedUserIds', 'action', 'agences', 'authorities', 'bulkService'];

    function UserManagementBulkEditDialogController($uibModalInstance, selectionCount, selectedUserIds, action, agences, authorities, bulkService) {
        var vm = this;

        vm.agences = agences;
        vm.authorities = authorities;
        vm.isSaving = false;
        vm.selectionCount = selectionCount;
        vm.form = {
            userIds: selectedUserIds,
            operation: action,
            authority: null,
            agenceId: null
        };

        vm.clear = clear;
        vm.save = save;
        vm.isAuthorityAction = isAuthorityAction;
        vm.isAgenceAction = isAgenceAction;
        vm.getTitleKey = getTitleKey;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            bulkService.bulkUpdate(vm.form, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isAuthorityAction() {
            return vm.form.operation === 'ADD_AUTHORITY' || vm.form.operation === 'REMOVE_AUTHORITY';
        }

        function isAgenceAction() {
            return vm.form.operation === 'ADD_AGENCE' || vm.form.operation === 'REMOVE_AGENCE';
        }

        function getTitleKey() {
            return 'userManagement.bulk.actions.' + vm.form.operation;
        }
    }
})();
